export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店同住三天被拍实锤',
    slug: 'dingliu-nanxing-mi-hui',
    excerpt: '近日有媒体拍到某当红顶流男星深夜与一名神秘女子一同进入某五星级酒店，两人在酒店内共度三天。据知情人透露...',
    content: `<p>近日，知名狗仔团队"真相追击"发布了一组重磅照片，拍到某当红顶流男星深夜与一名神秘女子一同进入某五星级酒店的画面。</p>
<p>据拍摄者透露，该男星当晚结束活动后并未返回住所，而是直接驱车前往位于朝阳区的某五星级酒店。一辆黑色商务车停在地下车库后，男星先下车，随后一名身穿黑色连衣裙的神秘女子也从同一辆车中走出。</p>
<p>两人一前一后进入电梯，直接到达了酒店顶层套房。知情人士透露，该套房一晚价格高达数万元。</p>
<p>更令人震惊的是，两人在酒店内共度了整整三天。期间，男星曾通过助理点餐送到房间门口，全程小心翼翼地避免被认出。直到第四天凌晨，两人才分开离开酒店。</p>
<p>目前，该男星的经纪团队尚未对此事做出回应。粉丝群体内部也出现了分裂，一部分粉丝坚决否认，称只是正常社交；另一部分粉丝则表示"如果是真的就祝福"。</p>
<p>值得注意的是，该男星此前曾在多个公开场合表示自己目前单身，专注于事业。这次的偷拍事件无疑给他的"单身人设"带来了巨大挑战。</p>
<h3>网友热评</h3>
<p>"三天三夜？这是有多想不开啊"</p>
<p>"粉丝还在洗，实锤都拍到脸了"</p>
<p>"坐等工作室发声明：只是朋友聚会"</p>`,
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Dark%20silhouette%20of%20a%20celebrity%20walking%20into%20a%20luxury%20hotel%20at%20night%2C%20paparazzi%20style%20photography%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20urban%20night%20scene%20with%20neon%20reflections&width=800&height=450&seq=article-1&orientation=landscape',
    publishDate: '2026-08-07',
    views: 285600,
    tags: ['顶流男星', '恋情曝光', '偷拍实锤'],
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '网红主播直播中翻车，背景意外暴露与多名金主聊天记录',
    slug: 'wanghong-zhibo-fanche',
    excerpt: '某知名带货主播在直播过程中，背景屏幕意外亮起，暴露了与多名"金主"的聊天记录，内容涉及私下交易和分成协议...',
    content: `<p>昨晚，一场原本平常的直播带货突然变成了一场"年度大戏"。某拥有千万粉丝的知名带货主播，在介绍一款护肤品时，身后的备用手机屏幕突然亮起，微信聊天记录清晰可见。</p>
<p>眼尖的网友迅速截图放大，发现聊天内容涉及与多名"金主"的私下交易。聊天记录显示，该主播与品牌方的分成远远高于公开宣称的比例，甚至还有要求品牌方提供"特殊服务"的内容。</p>
<p>事发后，该主播愣住几秒后迅速关闭了直播，但此时直播间人数已经突破百万，截图在各大社交平台疯传。</p>
<p>业内人士分析，这次翻车事件可能牵扯出更大的网红带货灰色产业链。多个品牌方可能会因此受到牵连，面临税务和商业合规的调查。</p>
<p>截至目前，该主播的社交账号已经设为私密，其所属MCN机构也未发布任何声明。</p>
<h3>事件后续</h3>
<p>多个品牌方已紧急下架与该主播相关的合作内容。平台方表示正在调查此事，若情况属实则将永久封禁该主播账号。</p>`,
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Livestreaming%20studio%20with%20a%20shocked%20expression%20on%20a%20streamer%20face%2C%20phone%20screen%20showing%20chat%20messages%2C%20dramatic%20moment%2C%20bright%20ring%20light%2C%20streaming%20equipment%20visible&width=800&height=450&seq=article-2&orientation=landscape',
    publishDate: '2026-08-06',
    views: 423100,
    tags: ['直播翻车', '带货主播', '私下交易'],
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '某女星被曝整容失败，医院内部病历流出引发轩然大波',
    slug: 'nvxing-zhengrong-shibai',
    excerpt: '一份疑似某知名女星的整容病历在网络上流传，详细记录了多次整容手术的具体项目和费用，合计高达数百万...',
    content: `<p>近日，一份疑似某知名女星的整容医院内部病历在网络上广泛传播，引发了网友热议。</p>
<p>该病历详细记录了该女星从2019年至2026年间进行的多次整容手术，包括鼻部整形、下颌角削骨、面部脂肪填充、胸部整形等多个项目。病历上清晰标注了手术日期、主刀医生、手术费用等信息，合计花费高达数百万元。</p>
<p>更令人震惊的是，病历中还记录了多次"修复手术"，显示之前的整形效果并不理想，出现了假体移位、疤痕增生等并发症。</p>
<p>医疗行业专家指出，整容病历属于个人隐私，医院泄露患者隐私已涉嫌违法。该医院可能面临严重的法律后果。</p>
<p>该女星工作室发布声明，强烈谴责泄露隐私的行为，并表示将通过法律途径维权。但声明中并未直接否认整容传闻，这让不少网友更加确信病历的真实性。</p>
<h3>行业反思</h3>
<p>此事件也引发了关于娱乐圈整容风气的讨论。有评论认为，过度追求外表完美已经让不少艺人陷入了整容的恶性循环。</p>`,
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Medical%20document%20with%20blurred%20surgical%20details%20on%20a%20desk%2C%20dramatic%20lighting%2C%20privacy%20breach%20theme%2C%20dark%20and%20mysterious%20atmosphere%2C%20hospital%20setting&width=800&height=450&seq=article-3&orientation=landscape',
    publishDate: '2026-08-05',
    views: 356800,
    tags: ['女星整容', '病历泄露', '隐私侵犯'],
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: '综艺节目导演被曝潜规则选手，多名参赛者实名举报',
    slug: 'zongyi-daoyan-qiangguize',
    excerpt: '某热门选秀综艺的导演被多名参赛选手实名举报存在潜规则行为，包括要求选手陪酒、索要财物等不当行为...',
    content: `<p>一场席卷某热门选秀综艺的丑闻正在发酵。多名曾经参加该节目的选手联合实名举报，指控节目导演存在长期的潜规则行为。</p>
<p>举报信中详细列举了该导演的不当行为，包括：强制要求女选手参加私人饭局、暗示"陪好导演就能多镜头"、向选手索要名牌礼物等。部分举报人还提供了聊天记录和转账凭证作为证据。</p>
<p>其中一位化名"小雨"的选手在接受采访时泣不成声："我当时太想红了，以为这是行业的潜规则，后来才发现自己有多傻。"</p>
<p>该节目的制作方已发布声明，表示已成立专项调查组，涉事导演已被停职接受调查。节目组承诺将严肃处理此事，绝不姑息。</p>
<p>然而，有业内人士爆料，该导演在圈内风评一向不佳，此前就多次被投诉，但都被压制了下来。这次之所以曝光，是因为得罪了某个有背景的选手。</p>
<h3>网友反应</h3>
<p>"选秀节目早就变味了，都是资本的玩物"</p>
<p>"希望能借此机会整治整治这个行业"</p>`,
    category: '综艺翻车',
    categorySlug: 'zongyi-fanche',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dark%20backstage%20area%2C%20dramatic%20lighting%20contrast%2C%20mysterious%20and%20tense%20atmosphere%2C%20television%20studio%20setting&width=800&height=450&seq=article-4&orientation=landscape',
    publishDate: '2026-08-04',
    views: 512000,
    tags: ['综艺丑闻', '潜规则', '导演被查'],
    featured: false,
    hot: true,
  },
  {
    id: 5,
    title: '知名歌手被曝假唱十年，演唱会现场音频对比铁证如山',
    slug: 'zhiming-geshou-jiachang',
    excerpt: '技术博主通过音频分析对比，发现某天王级歌手近十年的演唱会几乎全程使用预录人声，真实唱功与CD相差甚远...',
    content: `<p>一位技术博主近日发布了一条引爆网络的视频，通过专业音频软件对比分析，指出某天王级歌手近十年的演唱会几乎全程使用预录音频。</p>
<p>该博主选取了该歌手2016年至2026年间的12场演唱会录音，使用频谱分析和人声提取技术，发现多场演唱会的波形图几乎完全一致。正常的现场演唱不可能产生如此精确匹配的波形。</p>
<p>更夸张的是，博主发现即使在同一首歌的不同场次中，连"喘气声"的位置和时长都一模一样，这进一步证实了预录人声的使用。</p>
<p>该歌手此前曾多次在公开场合标榜自己"从不假唱"，甚至批评过假唱行为。这次曝光让粉丝们感到极度背叛。</p>
<p>音乐行业专家分析，近年来大型演唱会普遍存在"半开麦"或"全程垫音"的情况，主要是因为歌手年龄增长导致唱功下降，加上演出密度太大，声带无法承受。</p>
<p>目前该歌手团队尚未回应。多地消费者协会已接到粉丝投诉，要求退票。</p>
<h3>粉丝反应</h3>
<p>"十年粉转黑，感觉自己被骗了十年"</p>
<p>"退钱！我是去听现场的不是去听CD的！"</p>`,
    category: '音乐圈乱象',
    categorySlug: 'yinyuequan-luanxiang',
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20a%20singer%20performing%20under%20spotlights%2C%20audio%20waveform%20overlay%2C%20dramatic%20atmosphere%2C%20large%20crowd%20silhouette%2C%20dark%20and%20moody%20lighting&width=800&height=450&seq=article-5&orientation=landscape',
    publishDate: '2026-08-03',
    views: 689000,
    tags: ['假唱', '演唱会', '音频分析'],
    featured: true,
    hot: true,
  },
  {
    id: 6,
    title: '某带货主播被曝卖假货，消费者集体维权要求退一赔三',
    slug: 'daihuo-zhubo-jiahuo',
    excerpt: '近百名消费者联名投诉某头部带货主播销售假冒奢侈品，经专业鉴定确认产品为高仿，消费者已联合发起诉讼...',
    content: `<p>近百名消费者近日联名向市场监管部门投诉，指控某拥有五千万粉丝的头部带货主播销售假冒奢侈品牌产品。</p>
<p>据悉，该主播在去年双十一期间的一场直播中，以"正品保证、假一赔三"为卖点，销售了一批声称是某国际奢侈品牌的包袋和配饰。然而，收到货的消费者发现产品做工粗糙，与专柜正品存在明显差异。</p>
<p>部分消费者将产品送往专业鉴定机构进行检测，结果确认这些产品均为高仿品，使用了劣质材料和仿冒五金件。鉴定报告显示，产品的成本可能不到售价的十分之一。</p>
<p>消费者们已联合委托律师事务所提起诉讼，要求该主播和供货商按照承诺"退一赔三"进行赔偿。涉及金额可能高达数千万元。</p>
<p>该主播在事件曝光后发布道歉视频，但将责任推给了供应链团队，称自己也是受害者。然而，网友并不买账，指出该主播曾在直播中信誓旦旦地保证产品是正品。</p>
<h3>平台回应</h3>
<p>直播平台已冻结该主播的保证金，并表示将配合有关部门调查。多个品牌方也宣布终止与该主播的合作。</p>`,
    category: '直播带货瓜',
    categorySlug: 'zhibo-daihuogua',
    image: 'https://readdy.ai/api/search-image?query=Fake%20luxury%20handbags%20scattered%20on%20a%20table%20with%20magnifying%20glass%2C%20consumer%20rights%20theme%2C%20investigative%20atmosphere%2C%20bright%20studio%20lighting%20contrasting%20with%20dark%20background&width=800&height=450&seq=article-6&orientation=landscape',
    publishDate: '2026-08-02',
    views: 534000,
    tags: ['假货', '消费者维权', '直播带货'],
    featured: false,
    hot: false,
  },
  {
    id: 7,
    title: '体育明星婚内出轨被拍，小三竟是同队队友妻子',
    slug: 'tiyu-mingxing-hunneichugui',
    excerpt: '某知名体育明星被拍到与同队队友的妻子在酒店幽会，出轨对象身份曝光后体坛震动，当事人妻子已提出离婚...',
    content: `<p>体坛再次爆出重磅丑闻。某知名体育明星被拍到与同队队友的妻子多次在酒店幽会，照片和视频证据确凿。</p>
<p>据狗仔团队透露，他们跟踪该体育明星长达三个月，拍到了至少五次与同一名女子秘密约会的画面。该女子被证实是其同队多年队友的妻子，两人育有一个三岁的孩子。</p>
<p>知情人透露，两人的不正当关系已经持续了近一年。该体育明星的妻子在得知消息后已通过律师提出离婚，并要求分割财产和获得孩子抚养权。</p>
<p>更令人唏嘘的是，该体育明星与其队友曾是公认的"黄金搭档"，在赛场上配合默契，私下也以兄弟相称。这次出轨事件无疑彻底摧毁了这段友谊和信任。</p>
<p>该体育明星所在俱乐部已发布声明，表示将根据内部调查结果做出相应处理。多个品牌代言方也暂停了与该运动员的合作。</p>
<h3>体育圈反应</h3>
<p>多名退役运动员公开批评该行为"有辱体育精神"，呼吁加强运动员的道德教育。</p>`,
    category: '体育圈内幕',
    categorySlug: 'tiyuquan-neimu',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20dusk%2C%20a%20couple%20silhouette%20walking%20together%2C%20paparazzi%20style%2C%20dramatic%20warm%20lighting%2C%20scandal%20theme%2C%20urban%20setting&width=800&height=450&seq=article-7&orientation=landscape',
    publishDate: '2026-08-01',
    views: 445000,
    tags: ['体育明星', '婚内出轨', '兄弟背叛'],
    featured: false,
    hot: false,
  },
  {
    id: 8,
    title: '电竞战队内部不和大曝光，选手互相甩锅聊天记录流出',
    slug: 'dianjing-zhandui-neibumaodun',
    excerpt: '某顶级电竞战队内部聊天记录意外流出，揭示队员之间存在严重矛盾，比赛失利后将责任互相推诿...',
    content: `<p>电竞圈再次掀起波澜。某顶级电竞战队的内部工作群聊天记录被意外流出，揭示了战队内部存在的严重矛盾。</p>
<p>聊天记录显示，在最近一次重要赛事失利后，队员们在工作群中展开了激烈的争吵。打野选手指责中单选手"只顾刷数据不管团队"，中单则回怼打野"gank永远慢一步"。ADC选手和辅助选手也在群里互撕，场面一度失控。</p>
<p>更尴尬的是，教练在群里的发言也被曝光，内容显示教练偏袒某些选手，在战术安排上存在明显不公。这进一步加剧了队内的分裂。</p>
<p>战队管理层紧急召开闭门会议，试图平息内讧。但有消息称，至少两名核心选手已经在接触其他战队，准备在转会期离开。</p>
<p>粉丝群体也因此分裂，各自支持不同的选手，在社交媒体上展开了激烈的骂战。</p>
<h3>业内分析</h3>
<p>电竞评论员指出，战队内部沟通不畅是导致成绩下滑的主要原因。如果不能尽快解决内部矛盾，这支曾经的王者之师可能会在接下来的赛季中持续低迷。</p>`,
    category: '电竞风云',
    categorySlug: 'dianjing-fengyun',
    image: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20five%20gaming%20chairs%20arranged%2C%20dramatic%20split%20lighting%2C%20tension%20and%20conflict%20theme%2C%20dark%20atmosphere%20with%20RGB%20gaming%20lights%2C%20professional%20esports%20setting&width=800&height=450&seq=article-8&orientation=landscape',
    publishDate: '2026-07-31',
    views: 312000,
    tags: ['电竞', '战队内讧', '聊天记录'],
    featured: false,
    hot: false,
  },
  {
    id: 9,
    title: '某流量小花被扒学历造假，实际高中未毕业却自称名校海归',
    slug: 'liuliang-xiaohua-xueli-zaojia',
    excerpt: '网友深扒某当红流量小花的学历背景，发现其声称的海外名校留学经历完全造假，实际最高学历仅为高中肄业...',
    content: `<p>网友"学术打假"近日发布长文，详细扒出了某当红流量小花的真实学历背景，与其公开声称的教育经历存在巨大差距。</p>
<p>该小花在多个采访和综艺节目中曾表示自己毕业于"美国某知名大学"，拥有传媒学学士学位。然而，网友通过查询该校的校友数据库和毕业名册，均未找到该小花的任何记录。</p>
<p>进一步的调查发现，该小花实际上在国内只读到了高二就辍学了，后来确实去过美国，但只是在一所语言学校学习了几个月英语，从未被任何正规大学录取。</p>
<p>更讽刺的是，该小花还曾在某教育类综艺中担任"学霸人设"，给观众分享"留学生活"和"学习经验"。</p>
<p>事件曝光后，该小花的粉丝群体出现了大规模的脱粉潮。多个品牌方紧急评估是否需要终止代言合同。</p>
<h3>娱乐圈学历造假现象</h3>
<p>事实上，娱乐圈学历造假并非个例。据不完全统计，近年来已有超过十位艺人被曝出学历造假问题。业内人士指出，这反映了娱乐圈过度包装艺人的畸形生态。</p>`,
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Fake%20diploma%20certificate%20with%20a%20magnifying%20glass%20revealing%20inconsistencies%2C%20dramatic%20lighting%2C%20academic%20fraud%20theme%2C%20dark%20moody%20office%20setting&width=800&height=450&seq=article-9&orientation=landscape',
    publishDate: '2026-07-30',
    views: 378000,
    tags: ['学历造假', '流量小花', '人设崩塌'],
    featured: false,
    hot: false,
  },
  {
    id: 10,
    title: '网红情侣分手大戏：互相爆料对方黑历史，聊天记录长达百页',
    slug: 'wanghong-qinglv-fenshou',
    excerpt: '一对拥有千万粉丝的网红情侣突然宣布分手，随后双方在社交媒体上互爆黑料，公开了多达百余页的私密聊天记录...',
    content: `<p>网红圈的"年度分手大戏"正在上演。一对拥有千万粉丝的网红情侣在宣布分手仅仅24小时后，就在社交媒体上掀起了一场互爆黑料的战争。</p>
<p>女方率先发布长文，指控男方在恋爱期间多次出轨、PUA精神控制、恶意欠款不还等行为。男方随即反击，发布数百张聊天截图，指控女方脾气暴躁、挥霍无度、甚至对其家人进行人身攻击。</p>
<p>双方公开的私密聊天记录合计超过百页，内容涉及金钱纠纷、感情背叛、家庭矛盾等，尺度之大令人咋舌。</p>
<p>粉丝群体也因此分裂为两大阵营，互相攻击对方偶像。两人的CP超话在一天之内从百万粉丝掉到了不足十万。</p>
<p>品牌方反应迅速，多个与两人有合作关系的品牌已紧急下架相关推广内容。</p>
<h3>公关危机</h3>
<p>公关专家分析，这场互撕对两人的事业都将造成不可逆的伤害。品牌最忌讳的就是合作艺人陷入负面舆论漩涡，短期内两人很难接到像样的商业合作。</p>`,
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Split%20heart%20cracked%20in%20half%20with%20digital%20chat%20bubbles%20floating%20around%2C%20dramatic%20breakup%20theme%2C%20dark%20and%20emotional%20atmosphere%2C%20smartphone%20screen%20glowing&width=800&height=450&seq=article-10&orientation=landscape',
    publishDate: '2026-07-29',
    views: 567000,
    tags: ['网红情侣', '分手互撕', '聊天记录'],
    featured: false,
    hot: true,
  },
  {
    id: 11,
    title: '某导演被曝片场耍大牌，当众辱骂群演致其当场晕倒',
    slug: 'daoyan-pianchang-shuadapai',
    excerpt: '有群演爆料某知名导演在片场态度恶劣，不仅随意辱骂工作人员，更因一名群演NG多次而将其骂至当场晕倒...',
    content: `<p>一则来自群演的爆料让某知名导演的"暴君"形象再次成为焦点。多名群演联合发声，控诉该导演在片场的恶劣行为。</p>
<p>据爆料，该导演在拍摄一部古装剧时，对工作人员和群演态度极其恶劣。他会因为一点小事就破口大骂，用词之难听令人发指。</p>
<p>最严重的一次，一名女性群演因为紧张NG了三次，该导演当场用极其难听的话辱骂她，导致该群演情绪崩溃当场晕倒。现场的副导演和工作人员无人敢上前劝阻。</p>
<p>事后，该导演非但没有道歉，反而对制片人说"这种素质的群演以后不要用了"。剧组的医护人员透露，该群演被送医后被诊断为过度换气综合征。</p>
<p>此事在业内引起公愤。多名演员和导演公开谴责这种"片场暴力"行为，呼吁行业协会建立黑名单制度。</p>
<h3>行业问题</h3>
<p>娱乐圈的职场霸凌问题由来已久。有业内人士指出，很多大导演仗着自己的地位，在片场为所欲为，工作人员敢怒不敢言。</p>`,
    category: '影视八卦',
    categorySlug: 'yingshi-bagua',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20a%20director%20chair%20and%20megaphone%2C%20dramatic%20tension%20in%20the%20air%2C%20dark%20shadows%2C%20movie%20production%20setting%2C%20powerful%20and%20intimidating%20atmosphere&width=800&height=450&seq=article-11&orientation=landscape',
    publishDate: '2026-07-28',
    views: 289000,
    tags: ['导演耍大牌', '片场暴力', '群演维权'],
    featured: false,
    hot: false,
  },
  {
    id: 12,
    title: '某音乐节被曝黑幕：晋级名额明码标价，十万一个保送决赛',
    slug: 'yinyuejie-heimu',
    excerpt: '某大型音乐选秀节目的内部人士爆料，比赛晋级名额早已内定，参赛者可以通过付费获得保送资格，价格从十万起...',
    content: `<p>一场关于音乐选秀节目公平性的争议正在发酵。某知名音乐节的内部工作人员匿名爆料，揭露了节目背后令人震惊的"付费晋级"内幕。</p>
<p>据该爆料人透露，节目组设立了一套完整的"收费体系"：保送海选晋级3万元，保送初赛晋级5万元，保送半决赛8万元，保送决赛10万元。更有甚者，如果愿意支付20万元，可以直接获得"最佳新人奖"。</p>
<p>爆料人还提供了多张银行转账记录截图作为证据，付款方备注中清晰写着"XX选手晋级费"。</p>
<p>该音乐节的主办方紧急发布声明，否认所有指控，称将追究造谣者的法律责任。但在声明发布后，又有第二名"内部人士"站出来证实了爆料内容的真实性。</p>
<p>多个音乐人和乐队公开表示将退出该音乐节的后续比赛。赞助商也在评估是否需要撤资。</p>
<h3>选秀公平性讨论</h3>
<p>事实上，选秀节目黑幕问题早已不是什么秘密。从早期的短信投票造假，到如今的直接卖名额，选秀节目越来越背离了"公平选拔"的初衷。</p>`,
    category: '音乐圈乱象',
    categorySlug: 'yinyuequan-luanxiang',
    image: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20judges%20panel%2C%20dramatic%20spotlight%2C%20hidden%20money%20envelope%20in%20shadow%2C%20corruption%20theme%2C%20contrasting%20light%20and%20dark%20areas&width=800&height=450&seq=article-12&orientation=landscape',
    publishDate: '2026-07-27',
    views: 334000,
    tags: ['音乐节黑幕', '付费晋级', '选秀造假'],
    featured: false,
    hot: false,
  },
];